import {Pipe, PipeTransform} from '@angular/core';
import {HolidayModel} from '../../api/models/holiday-model';
import {DateTime} from 'luxon';

@Pipe({
    name: 'holidaysRange',
    standalone: true
})
export class HolidaysRangePipe implements PipeTransform {
  transform(holidays: HolidayModel[]): string {
    if (!holidays || !holidays.length) {
      return '';
    }

    const startDates: DateTime[] = [];
    const endDates: DateTime[] = [];

    for (const holiday of holidays) {
      if (!holiday.dates || !holiday.dates.length) {
        continue;
      }

      const [start, end] = this.getMinMaxDatesWithMinutes(holiday.dates, holiday.startTime, holiday.endTime);

      if (start.isValid) {
        startDates.push(start);
      }

      if (end.isValid) {
        endDates.push(end);
      }
    }

    const startDate = DateTime.min(...startDates);
    const endDate = DateTime.max(...endDates);

    if (!startDate.isValid || !endDate.isValid) {
      return '';
    }

    return `${startDate.toFormat('M/dd/yyyy hh:mm a')} - ${endDate.toFormat('M/dd/yyyy hh:mm a')}`;
  }

  getMinMaxDatesWithMinutes(holidayDates: string[], startMinutes: number, endMinutes: number): [DateTime | null, DateTime | null] {
    if (holidayDates.length === 0) {
      return [null, null];
    }

    let dateArray: DateTime[] = holidayDates.map(date => DateTime.fromJSDate(new Date(date)));

    // Find min and max dates
    const minDate = DateTime.min(...dateArray);
    const maxDate = DateTime.max(...dateArray);

    // Append minutes to min and max dates
    const startDatetime = minDate.set({ hour: Math.floor(startMinutes / 60), minute: startMinutes % 60 });
    const endDatetime = maxDate.set({ hour: Math.floor(endMinutes / 60), minute: endMinutes % 60 });

    return [startDatetime, endDatetime];
  }
}
